module.exports = __webpack_public_path__ + "static/media/gallery-21.9cca0e11.jpg";